import { render } from "./TheUserLayout.vue?vue&type=template&id=3d4711a4"
import script from "./TheUserLayout.vue?vue&type=script&lang=js"
export * from "./TheUserLayout.vue?vue&type=script&lang=js"

import "./TheUserLayout.vue?vue&type=style&index=0&id=3d4711a4&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__